import { Component } from '@angular/core';

@Component({
  selector: 'templo-sabios-card',
  templateUrl: 'templo-sabios-card.html'
})
export class TemploSabiosCardComponent {

  constructor() {   }

  notImplement() {
    alert('Cerrado por remodelación :)')
  }

}



// WEBPACK FOOTER //
// ./src/components/templo-sabios-card/templo-sabios-card.ts